import { render } from "./widget_singleValue.vue?vue&type=template&id=3b0e253d&scoped=true"
import script from "./widget_singleValue.vue?vue&type=script&lang=js"
export * from "./widget_singleValue.vue?vue&type=script&lang=js"

import "./widget_singleValue.vue?vue&type=style&index=0&id=3b0e253d&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\horva\\Documents\\nodejs\\production\\enat05\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b0e253d"]])

export default __exports__